import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconLogoMobile = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={className}
            fill='none'
            viewBox='0 0 261 37'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M0 37H7.03175V18.5V0H0V37Z'
                fill={fill}/>
            <path
                d='M127.602 0V9.66573C127.602 15.1222 127.654 21.0463 127.81 27.5941C125.935 24.1124 123.33 19.8511 121.247 16.4733L110.882 0H103.069V37H109.84V27.3343C109.84 21.8778 109.84 15.9536 109.632 9.4059C111.507 12.9916 113.903 16.8371 116.247 20.5267L126.56 37H134.373V0H127.602Z'
                fill={fill}/>
            <path
                d='M260.5 0H251.749L234.405 17.4607V0H227.373V37H234.405V25.4115L240.238 19.7472L252.114 37H260.5L245.239 15.0702L260.5 0Z'
                fill={fill}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconLogoMobile;
